import React, { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context'
import Viewuser from '../components/View-user'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Userstatus from '../components/User_status';
import { useNavigate } from 'react-router-dom';


const Users = () => {
  const navigate = useNavigate();

  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Name", field: "name", },
    { label: "Mobile", field: "mobile", },
    { label: "Date Of Birth", field: "dob", },
    { label: "Location", field: "location", },
    { label: "Gender", field: "Gender", },
    { label: "Status", field: "status", },
    // { label: "Consultations Left", field: "consultationsleft", },
    { label: "Actions", field: "action", },
    { label: "Created Date", field: "createddDate", },
    // { label: "Last Updated Date", field: "UpdatedDate",  },
  ];

  const title = { name: "Users", subheading: "Follow up with the users", search: "Search Name", }
  const SortOptions = ['None', 'name', 'mobile', 'createdAt']
  const UserOptions = ['Active', 'Inactive'];
  const Consulationleftoptions = ['Yes', 'No'];
  const Genderoptions = ['Male', 'Female', 'Other'];
  //usestate define
  const { loading, setLoading } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const [customers, setCustomers] = useState([])
  const [getcustomers, setgetCustomers] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [totalpages, setTotalPages] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const [search, setSearch] = useState();
  const [sortstatus, setSortStatus] = useState();
  const [userStatus, SetUserStatus] = useState()
  // const [consultationLeft, SetConsultationLeft] = useState()
  const [gender, SetGender] = useState()
  const rowsperpage = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleCloseFilter = () => setAnchorEl(null);

  const formatDate = (date) => {
    const d = new Date(date);
    return isNaN(d.getTime()) ? "---" : d.toLocaleDateString("en-GB");
  };
  //fetch Customer
  const fetchCustomers = async (search, currentPage, rowsperpage, sortstatus, userStatus, gender) => {
    const params = {
      search,
      page: currentPage,
      limit: rowsperpage,
      // sortBy: "createdAt",
      // sortOrder: "desc",
      ...(sortstatus && sortstatus !== 'None' ? { sortBy: sortstatus } : {}),
      ...(userStatus && userStatus !== 'None' ? { status: userStatus } : {}),
      // ...(consultationLeft && consultationLeft !== 'None' ? { consultations_left: consultationLeft } : {}),
      ...(gender && gender !== 'None' ? { Gender: gender } : {}),
    };
    try {
      const response = await instance.get('/Customer/getCustomers', { params });
      const formatteddata = response?.data?.data?.map((customer, index) => ({
        sno: index + 1,
        name: customer?.name || "---",
        mobile: customer?.mobile || "---",
        dob: formatDate(customer?.dob) || "---",
        location: customer?.location || "---",
        Gender: customer?.Gender || "---",
        status: customer?.status,
        consultationsleft: customer?.consultations_left === true ? "Yes" : "No" || "---",
        createddDate: customer?.createdAt
          ? new Date(customer.createdAt).toLocaleDateString("en-GB")
          : "---",
        UpdatedDate: customer?.updatedAt
          ? new Date(customer.createdAt).toLocaleDateString("en-GB")
          : "---",
        customerId: customer?._id || "---",
        profile_pic: customer?.profile_pic || "---",
        size: customer?.size || "---",
      }))
      setCustomers(formatteddata);
      setTotalPages(response?.data?.totalPages);
      setCurrentPages(response?.data?.currentPage);
      setTotalcount(response?.data?.total);
    }
    catch (error) {
      console.log("error to fetch Customer:", error.message)
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchCustomers(search, currentPage, rowsperpage, sortstatus, userStatus, gender)
    setgetCustomers(false)
    setLoading(true);
  }, [getcustomers, search, currentPage, rowsperpage])


  const handleViewClick = (customer) => {
    setSelectedCustomers(customer);
    setopenviewDialog(true)
  }

  const handleStatusClick = (customer) => {
    setSelectedCustomers(customer);
    setstatusDialog(true);
  };

  const handleCartClick = (customer) => {
    navigate(`/admin/addtocart/${customer.customerId}`);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const handleUserApplyFilter = () => {
    fetchCustomers(search, currentPage, rowsperpage, sortstatus, userStatus, gender)
    setAnchorEl(null);
  };

  const handleClearFilter = () => {
    // SetConsultationLeft("");
    SetUserStatus("");
    setSortStatus("");
    SetGender("");
    setSearch("");

    setCurrentPages(1);

    handleCloseFilter();
    setgetCustomers(true);
  };

  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          showButton={false}
          title={title}
          setSearch={setSearch}
        />
        <SubHeader
          menu={false}
          filter={true}
          isVisible={true}
          isUserpage={true}
          anchorEl={anchorEl}
          open={open}
          handleClick={handleClick}
          sortstatus={sortstatus}
          setSortStatus={setSortStatus}
          SortOptions={SortOptions}
          handleCloseFilter={handleCloseFilter}
          handleUserApplyFilter={handleUserApplyFilter}
          handleClearFilter={handleClearFilter}
          UserOptions={UserOptions}
          userStatus={userStatus}
          SetUserStatus={SetUserStatus}
          // Consulationleftoptions={Consulationleftoptions}
          // consultationLeft={consultationLeft}
          // SetConsultationLeft={SetConsultationLeft}
          Genderoptions={Genderoptions}
          gender={gender}
          SetGender={SetGender}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            cart={true}
            banner={true}
            columns={columns}
            rows={customers}
            openviewDialog={openviewDialog}
            setopenviewDialog={setopenviewDialog}
            handleViewClick={handleViewClick}
            handleStatusClick={handleStatusClick}
            handleCartClick={handleCartClick}
            totalpages={totalpages}
            rowsperpage={rowsperpage}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPages={setCurrentPages}
          />
        }
        <Viewuser
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedCustomers={selectedCustomers}
        />
        <Userstatus
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedCustomers={selectedCustomers}
          setgetCustomers={setgetCustomers}
        />

      </section>
    </>
  )
}

export default Users;
